import * as React from "react"
export const Svg_017 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={58}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path fill="url(#b)" d="M59 55.525v-24.57L43.751 42.543 59 55.525Z" />
      <path fill="url(#c)" d="M59 26.66v-6.718h-6.914v11.972L59 26.659Z" />
      <path fill="url(#d)" d="M6.914 19.942H0v6.718l6.914 5.254V19.942Z" />
      <path fill="url(#e)" d="M0 30.955v24.57l15.249-12.982L0 30.955Z" />
      <path
        fill="url(#f)"
        d="M18.62 44.168 2.374 58h54.254L40.38 44.168H18.621Z"
      />
      <path
        fill="url(#g)"
        d="M18.567 40.77h21.866l8.196-6.23V0H10.37v34.54l8.196 6.23ZM30.16 18.175h-1.32c-2.902 0-5.264-2.322-5.264-5.175 0-2.493 1.804-4.58 4.195-5.067v-2.27h3.457v2.2c2.363.297 4.195 2.287 4.195 4.689h-3.457a1.34 1.34 0 0 0-1.35-1.328H28.84c-.996 0-1.807.797-1.807 1.776 0 .98.81 1.776 1.807 1.776h1.32c2.902 0 5.263 2.321 5.263 5.175 0 2.493-1.803 4.58-4.195 5.067v2.27h-3.457v-2.2c-2.362-.298-4.195-2.287-4.195-4.689h3.457a1.34 1.34 0 0 0 1.351 1.328h1.776c.996 0 1.807-.797 1.807-1.776 0-.98-.811-1.776-1.807-1.776Zm-11.113 13.87H40.01v3.399H19.047v-3.398Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={47.278}
        x2={60.327}
        y1={34.64}
        y2={47.748}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={53.685}
        x2={60.029}
        y1={21.738}
        y2={27.668}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={1.599}
        x2={7.943}
        y1={21.738}
        y2={27.668}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={3.526}
        x2={16.576}
        y1={34.64}
        y2={47.748}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={14.919}
        x2={17.178}
        y1={46.242}
        y2={60.58}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={19.218}
        x2={39.11}
        y1={6.115}
        y2={36.325}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h59v58H0z" />
      </clipPath>
    </defs>
  </svg>
)